import { useEffect, useMemo } from 'react';
import { generatePath, Route, useHistory, useRouteMatch } from 'react-router';

const buildRedirect: (to: string) => React.FC = to => () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    history.replace(generatePath(to, match.params));
  });

  return null;
};

export const Replace: React.FC<{
  to: string;
  from: string;
}> = ({ from, to }) => {
  const Redirect = useMemo(() => buildRedirect(to), [to]);

  return <Route path={from} component={Redirect} />;
};
